import GamesReport from "./GamesReport";

export default GamesReport;
